import React, {memo} from 'react';
import {useBackground} from '../../../../hooks/background-class';

import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {onClickHandler} from '../../../../utils/onclick';
import './index.scss';
import {Configs} from '../../../../configs';
import {useFilterSelector} from '../../../../hooks/filter-selector';
import {useOrientation} from '../../../../hooks/orientation';
import {MediaFileTag} from '../../../../store/ui/state';

const MyButton = memo(function MyButton({icon, onClick}: { icon?: string; onClick: () => void }) {
    return (
        <div className="button" {...onClickHandler(onClick)}>
            <img src={icon} alt=""/>
        </div>
    );
});

export const BackgroundSettingsScreen = memo(function BackgroundSettingsScreen() {
    const [, changeBackground, backgroundStyle] = useBackground();
    const orientation = useOrientation('horizontal');
    const backgroundList = useFilterSelector(state => state.ui.mediaFileList, media => media.type === 'background' && media.tags.includes(orientation as MediaFileTag),[orientation]);

    return (
        <PasswordContainer requiredRole='default' isFullscreen={true}>
            <SettingsPageContainer buttons={[]}
                                   backUrl={'/settings'}
                                   className={'background-settings'}
                                   style={backgroundStyle}>
                <div className={'background-settings-screen'}>
                    {
                        backgroundList.map(image => (
                            <MyButton
                                key={image.url}
                                icon={`${Configs.IMAGE_PREFIX}/media/${image.id}`}
                                onClick={() => changeBackground(image.id)}/>
                        ))
                    }
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
